import gql from 'graphql-tag';

export const CATEGORIES_QUERY = {
  es: gql`
    query ProjectCategories {
      projectCategories {
        id
        name: name_es
        description: description_es
        icon
      }
    }
  `,
  en: gql`
    query ProjectCategories {
      projectCategories {
        id
        name: name_en
        description: description_en
        icon
      }
    }
  `
};
